import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  buttonsStyle,
  dateFormatter,
} from "../../../components/tables/table";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import {
  changeStatusCategoria,
  deleteCategoria,
  getCategorias,
} from "../../../../api/categoria";
import FiltersCard from "../../../components/filters/Filter";
import {
  Button,
  CircularProgress,
  FormControlLabel,
  InputLabel,
  makeStyles,
  Switch,
  TextField,
  Tooltip,
} from "@material-ui/core";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import DeleteIcon from "@material-ui/icons/Delete";
import { Autocomplete } from "@material-ui/lab";
import {
  Edit,
  WebAsset,
  WebAssetOutlined,
  WebAssetRounded,
  WebAssetTwoTone,
} from "@material-ui/icons";
import { shallowEqual, useSelector } from "react-redux";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getNonEmpty } from "../../../../utils/helpers";

function getData(categorias) {
  let data = [];
  for (let i = 0; i < categorias.length; ++i) {
    const elem = {};
    elem.nombre = getNonEmpty(categorias[i]?.name);
    elem.active = categorias[i]?.active;
    elem.web = categorias[i]?.web;
    elem.createdAt = categorias[i]?.createdAt;
    elem.id = categorias[i]?._id;
    data = data.concat(elem);
  }
  return data;
}

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function CategoriasPage() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [categoria, setCategoria] = useState({});
  const [categoriaId, setCategoriaId] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const history = useHistory();
  const classes = useStyles();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const columns = [
    { dataField: "nombre", text: "Nombre", sort: true },
    { dataField: "createdAt", text: "Fecha", formatter: dateFormatter },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-categoria/" + cell)}
          >
            <Edit />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCategoria(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCategoria(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  useEffect(() => {
    setLoading(true);
    getCategorias()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setLoading(false);
          setRefresh(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        alertError({
          error: error,
          customMessage: "Could not get categorias.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Lista Categorias">
          <CardHeaderToolbar>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-categoria")}
            >
              Add
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table data={getData(filteredData)} columns={columns} />
          <ConfirmDialog
            title={`Are you sure you want to ${
              categoria?.active ? "disable" : "enable"
            } this brand?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusCategoria(categoria?._id, !categoria?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${categoria?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `Brand ${
                        categoria?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      categoria?.active ? "disable" : "enable"
                    } brand.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this brand?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteCategoria(categoria?._id)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Brand removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove brand.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
